import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import tooltip from "./directives/tooltip.js"
import "@/assets/tooltip.css";
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';

createApp(App).use(router).use(ElementPlus).directive("tooltip", tooltip).mount('#app')
